import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { expanded: { type: Boolean, default: true } }

  connect() {
    if (!this.expandedValue) {
      this.contentTarget.classList.add("hidden")
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(0deg)"
      }
    } else {
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(180deg)"
      }
    }
  }

  toggle() {
    if (this.contentTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.contentTarget.style.height = "0px"
    this.contentTarget.style.overflow = "hidden"
    this.contentTarget.style.transition = "height 0.3s ease-out"

    const naturalHeight = this.contentTarget.scrollHeight + "px"

    requestAnimationFrame(() => {
      this.contentTarget.style.height = naturalHeight
    })

    setTimeout(() => {
      this.contentTarget.style.height = "auto"
      this.contentTarget.style.overflow = "visible"
    }, 300)

    if (this.hasIconTarget) {
      this.iconTarget.style.transition = "transform 0.3s ease-out"
      this.iconTarget.style.transform = "rotate(180deg)"
    }

    this.expandedValue = true
  }

  close() {
    const currentHeight = this.contentTarget.scrollHeight + "px"
    this.contentTarget.style.height = currentHeight
    this.contentTarget.style.overflow = "hidden"
    this.contentTarget.style.transition = "height 0.3s ease-out"

    this.contentTarget.offsetHeight

    requestAnimationFrame(() => {
      this.contentTarget.style.height = "0px"
    })

    setTimeout(() => {
      this.contentTarget.classList.add("hidden")
      this.contentTarget.style.height = ""
      this.contentTarget.style.overflow = ""
      this.contentTarget.style.transition = ""
    }, 300)

    if (this.hasIconTarget) {
      this.iconTarget.style.transition = "transform 0.3s ease-out"
      this.iconTarget.style.transform = "rotate(0deg)"
    }

    this.expandedValue = false
  }
}
